























































import Vue from 'vue';
import * as operatoreSanitarioApi from '../services/operatore-sanitario-api';
import {
    OperatoreSanitarioList,
    OperatoreSanitarioListViewModel,
} from '../types';

export default Vue.extend({
    data(): OperatoreSanitarioListViewModel {
        return {
            columns: [
                {
                    text: this.$i18n.t('labels.operatore-sanitario'),
                    value: 'displayName',
                },
                {
                    text: this.$i18n.t('labels.qualifica'),
                    value: 'qualifica.valore',
                },
                {
                    text: this.$i18n.t('labels.attivo'),
                    value: 'attivo',
                },
            ],
            dataItems: [],
            search: '',
            selectedItems: [],
        };
    },
    computed: {
        canDelete(): boolean {
            return this.selectedItems.length > 0;
        },
    },
    methods: {
        async loadData(): Promise<void> {
            this.dataItems = await operatoreSanitarioApi.getList();
        },
        showDetail(item: OperatoreSanitarioList) {
            this.$router.push({
                name: 'OperatoreSanitarioDetail',
                params: { id: item.id.toString() },
            });
        },
        async deleteItems(): Promise<void> {
            if (
                await this.$confirm(
                    this.$t('dialog.default-question').toString(),
                    {
                        title: this.$t('dialog.delete-title').toString(),
                        color: 'secondary',
                        icon: 'mdi-delete',
                    }
                )
            ) {
                await operatoreSanitarioApi.remove(
                    this.selectedItems.map((p) => {
                        return {
                            id: p.id,
                            version: p.version,
                        };
                    })
                );
                await this.loadData();
            }
        },
    },
    mounted() {
        this.loadData();
    },
    watch: {
        $route: {
            handler: async function () {
                await this.loadData();
            },
            deep: true,
        },
    },
});
